<div class="row image-container">
  <div class="animated-background vehicle" *appTimes="count"></div>
</div>